// extracted by mini-css-extract-plugin
export const overviewBody = "compare-table-module--overviewBody--3qRKr";